"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var scrollable_area_1 = require("./scrollable-area");

var scrollableAreas = [];

function PreventOverScrolling(scrollableArea) {
  setEvents(true, scrollableArea);
}

exports.PreventOverScrolling = PreventOverScrolling;

function ReEnableOverScrolling(scrollableArea) {
  setEvents(false, scrollableArea);
}

exports.ReEnableOverScrolling = ReEnableOverScrolling;

function setEvents(enable, element) {
  var area = scrollableAreas.find(function (a) {
    return a.Element === element;
  });

  if (!area) {
    area = new scrollable_area_1.ScrollableArea(element);
    scrollableAreas.push(area);
  }

  area.SetEventListeners(enable);

  if (!enable) {
    scrollableAreas = scrollableAreas.filter(function (a) {
      return area;
    });
  }
}